<template>
    <metainfo> </metainfo>
    <v-app :class="{ 'capacitor-embed': isCapacitorEmbed }" color="white">
        <router-view />
        <v-dialog persistent v-model="signInForm" width="600">
            <v-card>
                <v-toolbar color="primary" class="white--text" flat>
                    <v-toolbar-title text-center>Login</v-toolbar-title>
                </v-toolbar>
                <!--
                    <template v-if="!isAuthAccountInProgress">
                        <v-btn
                            @click="closeSignInForm()"
                            density="comfortable"
                            variant="text"
                            :ripple="false"
                            icon
                        >
                            <v-icon :icon="mdiClose" />
                        </v-btn>
                    </template>
                    <template v-else>
                        <v-btn
                            density="comfortable"
                            variant="text"
                            :ripple="false"
                            icon
                        >
                            <v-icon :icon="mdiClose" />
                        </v-btn> </template
                    >-->

                <v-card-text class="pt-3 pb-0">
                    <v-alert
                        class="word-break ma-3"
                        type="error"
                        v-if="!!errorMessage"
                        v-html="errorMessage"
                    />
                    <v-alert class="word-break ma-3" type="success" v-if="!!signInMessage">{{
                        signInMessage
                    }}</v-alert>
                    <v-form ref="loginForm">
                        <v-text-field
                            label="Email Id"
                            color="primary"
                            density="compact"
                            class="textfield-border"
                            placeholder="Enter your email id"
                            type="email"
                            ref="email"
                            v-model="email"
                            :rules="emailRules"
                            :prepend-icon="mdiEmailOutline"
                            variant="underlined"
                        >
                        </v-text-field>

                        <v-text-field
                            type="password"
                            color="primary"
                            class="textfield-border"
                            label="Password"
                            placeholder="Enter your password"
                            ref="password"
                            density="compact"
                            v-model="password"
                            :rules="passwordRules"
                            :prepend-icon="mdiLock"
                            variant="underlined"
                        >
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="12" class="px-7">
                            <div class="text-right pt-5">
                                <v-hover v-slot="{ isHovering, props }">
                                    <v-btn
                                        :disabled="inProgress"
                                        size="large"
                                        block
                                        v-bind="props"
                                        :variant="isHovering ? 'flat' : 'outlined'"
                                        :class="
                                            isHovering ? 'bg-primary' : ' bg-white text-primary'
                                        "
                                        class="mt-1 body text-capitalize"
                                        type="submit"
                                        form="signin-form"
                                        rounded="0"
                                        @click="signIn()"
                                        ><v-progress-circular
                                            :size="20"
                                            :color="isHovering ? 'primary' : 'primary'"
                                            indeterminate
                                            v-if="isAuthAccountInProgress"
                                        ></v-progress-circular>
                                        Login</v-btn
                                    >
                                </v-hover>
                            </div>
                        </v-col>
                        <!--
                        <v-col cols="12" class="py-5" align="center">
                            <span
                                class="text-decoration-none cursor-pointer text-primary"
                                @click="goToForgetPassword()"
                                >Forgot Your Password?</span
                            > </v-col
                        >-->
                        <v-col cols="12" class="py-5" align="center">
                            <span
                                class="text-decoration-none cursor-pointer text-primary"
                                @click="goToHomePage()"
                                >Go Home</span
                            >
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import { getIsCapacitorEmbed } from '@/plugins/capacitorIframeBack'
const { mapFields: mapFieldsAuth } = createHelpers({
    getterType: 'auth/getField',
    mutationType: 'auth/updateField',
})
import { createHelpers } from 'vuex-map-fields'
import { mdiEmailOutline, mdiLock } from '@mdi/js'

export default {
    name: 'App',
    computed: {
        ...mapFieldsAuth(['one', 'one.email', 'one.password', 'errorMessage', 'signInMessage']),
        signInForm: function () {
            return this.$store.state.auth.showLoginDialog
        },
        isAuthAccountInProgress() {
            const state = this.$store.state
            return state.auth.inProgress || state.accountOne.inProgress
        },
        isCapacitorEmbed() {
            return getIsCapacitorEmbed()
        },
    },
    data: () => ({
        emailRules: [
            (v) => !!v || 'Email Id is required',
            (v) => /.+@.+\..+/.test(v) || 'Email Id must be valid',
        ],
        passwordRules: [
            (v) => !!v || 'Password is required',
            (v) => (v && v.length >= 8) || 'Password must be at least 8 characters',
        ],
        mdiEmailOutline,
        mdiLock,
    }),
    methods: {
        closeSignInForm() {
            this.signInForm = false
            this.$store.dispatch('auth/changeRedirectFlag', true)
        },

        async signIn() {
            let validate = await this.$refs.loginForm.validate()
            if (validate?.valid) {
                this.$store.dispatch('auth/changeRedirectFlag', false)

                let response = await this.$store.dispatch('auth/login')

                if (response) {
                    this.signInForm = false

                    // this.$store.dispatch("auth/changeRedirectFlag", true);
                    this.$store.dispatch('auth/closeLoginPopup')
                    // reload current page after login
                    window.location.reload()
                }
            }
        },

        goToForgetPassword() {
            window.open(`/gate/forgot-password`, '_self')
        },
        goToHomePage() {
            localStorage.removeItem('cr_checkOutTab')
            this.$store.dispatch('auth/logout')
            try {
                window.DD_RUM.onReady(function () {
                    window.DD_RUM.clearUser()
                })
            } catch (error) {
                console.error('error in dd user clear', error)
            }
            window.open('/', '_self')
        },
    },
    created() {
        try {
            let recaptchaInterval = null
            recaptchaInterval = setInterval(() => {
                let recaptchaBadge = document.getElementsByClassName('grecaptcha-badge')
                if (recaptchaBadge && recaptchaBadge.length && recaptchaBadge[0].style) {
                    recaptchaBadge[0].style.display = 'none'
                    clearInterval(recaptchaInterval)
                }
            }, 100)
        } catch (error) {
            console.error('recpatcha hide error', error)
        }
    },
}
</script>
<style src="./styles/_app.scss" lang="scss" />
